import { Input, Modal, Switch } from 'antd';
import { useState } from 'react';
import { apiNode } from '../../../../services/api';
import { ModalContainer, Content, CustomButton } from './styles';

import { IoCloseOutline } from 'react-icons/io5';

interface CreateLeagueModalProps {
  isOpen: boolean;
  closeModal: () => void;
  updateHasLeague: () => Promise<void>;
}

export const CreateLeagueModal = ({
  closeModal,
  isOpen,
  updateHasLeague,
}: CreateLeagueModalProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const [isPrivate, setIsPrivate] = useState(false);
  const [leagueName, setLeagueName] = useState('');

  const handleCreateLeague = async () => {
    try {
      setIsLoading(true);
      await apiNode.post('/ligas', {
        nome: leagueName,
        privada: isPrivate,
      });

      await updateHasLeague();
      closeModal();
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };
  return (
    <ModalContainer className="teste">
      <Modal
        visible={isOpen}
        onCancel={closeModal}
        bodyStyle={{ padding: 0 }}
        footer={[
          <CustomButton
            type="primary"
            onClick={handleCreateLeague}
            loading={isLoading}
            key="submitButton"
            style={{
              background: '#50915b',
              height: 50,
              width: '100%',
              fontSize: '1.5rem',
            }}
          >
            Registrar
          </CustomButton>,
        ]}
      >
        <Content>
          <span>
            <h1>Criar Liga</h1>
            <button type="button">
              <IoCloseOutline size={25} />
            </button>
          </span>
          <div>
            <p>
              Nome:
              <Input
                type="text"
                onChange={(event) => setLeagueName(event.target.value)}
                style={{ outline: 'none' }}
              />
            </p>
            <Switch
              checkedChildren="Privada"
              unCheckedChildren="Pública"
              onChange={() => setIsPrivate(!isPrivate)}
            />
          </div>
        </Content>
      </Modal>
    </ModalContainer>
  );
};
